import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const customQueueRoute: InvariantJiraRoute = {
	name: 'servicedesk-queues-custom-view',
	path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId',
	query: ['oldIssueView?'],
	exact: true,
};
